// 教學專欄 (/articles and /articles/:slug, D-270). The Worker sends the whole page as HTML (src/articles/render.ts);
// this route keeps that same node, moves it between the site header and footer and switches on the copy buttons.
// Nothing here renders article text, so the server and the app can never show two different versions.
import { useLayoutEffect, useRef, useState } from "react";
import { PublicFooter, PublicHeader } from "./app-core";
import { lp, t } from "./i18n";
import "./articles.css";

/** One-tap copy for :::copy blocks; falls back to selecting the text when the clipboard is not available. */
function enableCopyButtons(root: HTMLElement) {
  for (const button of root.querySelectorAll<HTMLButtonElement>("button[data-copy]")) {
    button.hidden = false;
    const label = button.textContent ?? "";
    button.addEventListener("click", () => {
      const text = document.getElementById(button.dataset.copy ?? "");
      if (!text) return;
      const done = () => { button.textContent = button.dataset.copied ?? label; window.setTimeout(() => { button.textContent = label; }, 2000); };
      const select = () => { const range = document.createRange(); range.selectNodeContents(text); const selection = getSelection(); selection?.removeAllRanges(); selection?.addRange(range); };
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(text.textContent ?? "").then(done, select);
      else select();
    });
  }
}

function ServerPage() {
  const slot = useRef<HTMLDivElement>(null);
  const [missing, setMissing] = useState(false);
  useLayoutEffect(() => {
    const main = document.getElementById("cm-ssr-main");
    if (!main || !slot.current) { setMissing(true); return; }
    if (main.parentElement === slot.current) return;
    slot.current.appendChild(main);
    document.getElementById("cm-ssr")?.remove();
    enableCopyButtons(main);
    if (location.hash) document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView();
  }, []);
  if (missing) return <main className="ar-page"><section className="ar-final"><p className="eyebrow">{t("找不到這一頁")}</p><h1>{t("這個頁面可能已經移動了")}</h1><p>{t("可以從功能介紹或教學文章重新找起。")}</p><div className="ar-actions"><a className="button primary" href={lp("/articles")}>{t("看教學文章")}</a><a className="button secondary" href={lp("/features")}>{t("看功能介紹")}</a></div></section></main>;
  return <div ref={slot} className="ar-slot" />;
}

export default function ArticlesRoute() {
  return <div className="ar-shell">
    <PublicHeader />
    <ServerPage />
    <PublicFooter />
  </div>;
}
